import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function submitQuote(data) {
  return axios.post(`${API}/quotes`, data);
}

export function adminLogin(email, password) {
  return axios.post(`${API}/admin/login`, { email, password });
}

export function fetchQuotes(token) {
  return axios.get(`${API}/quotes`, { headers: { Authorization: `Bearer ${token}` } });
}

export function fetchStats(token) {
  return axios.get(`${API}/quotes/stats`, { headers: { Authorization: `Bearer ${token}` } });
}

export function updateQuoteStatus(id, status, token) {
  return axios.patch(`${API}/quotes/${id}/status`, { status }, { headers: { Authorization: `Bearer ${token}` } });
}

export function updateQuoteNotes(id, notes, token) {
  return axios.patch(`${API}/quotes/${id}/notes`, { notes }, { headers: { Authorization: `Bearer ${token}` } });
}
